import { Button, HStack, Text } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { type CaptionProps, useNavigation } from 'react-day-picker';

import { Navbar } from '@/components/DayPicker/_partials/Navbar';

type CustomCaptionElementProps = CaptionProps & {
  setMonth(date?: Date): void;
  onCaptionLabelClick?(): void;
  withMonthPicker?: boolean;
};

export const Caption: React.FC<
  React.PropsWithChildren<CustomCaptionElementProps>
> = ({
  displayMonth,
  onCaptionLabelClick,
  setMonth,
  withMonthPicker = true,
}) => {
  const { previousMonth, nextMonth } = useNavigation();

  const monthText = `${dayjs(displayMonth).format(
    'MMMM'
  )} ${displayMonth.getFullYear()}`;

  return (
    <HStack py={3} justifyContent="space-between">
      <Navbar onPreviousClick={() => setMonth(previousMonth)} />
      {withMonthPicker ? (
        <Button
          color="gray.900"
          fontWeight="medium"
          variant="link"
          onClick={() => onCaptionLabelClick?.()}
          textTransform="capitalize"
        >
          {monthText}
        </Button>
      ) : (
        <Text
          fontWeight="medium"
          color="gray.600"
          fontSize="sm"
          textTransform="capitalize"
        >
          {monthText}
        </Text>
      )}
      <Navbar onNextClick={() => setMonth(nextMonth)} />
    </HStack>
  );
};
